<template>
    <div>
        <!-- Bookmark Popup  -->
        <first-run :which="whichPop" :onClose="onCloseHelp" :onNext="onNextPop"
        :pEngine.sync="productEngine" :saveSearchUrl="true" :firstRunSettings="branding.FirstRunSettings"/>
        <!-- First Run Popup -->
        <!----search module----->
        <div class="searchModule">
            <div class="sLogo"><img :src="branding.Logo"></div>
            <div class="search web">
                <input ref="queryInput" v-model='query' @return="toProductSearch()" @keydown.enter="toProductSearch()" @keyup="productEngine=findProductProvider(query,productEngine)" :placeholder="branding.AutocompletePlaceholder"/>
                <div class="s-icon"><i class="fa fa-search"></i></div>
                <div class="error" v-if="queryError">This field is required, please enter</div>
            </div>
            <div class="search-engine">
                <select id="product-engine" v-model='productEngine' class="productDropDown">
                    <option v-for="(provider, name) in productSearchProviders" :value="provider.id" :selected="provider.id == productEngine" >{{provider.name}}</option>
                </select>
                <div class="s-icon"><i class="fa fa-sort-desc "></i></div>
                <div class="engine-error" v-if="engineError" >Invalid Tracking number or mismatched Carrier type.</div>
            </div>
            <div class="sBtnContainer">
                <button class="btn-search productSearch" @click="toProductSearch()">{{branding.SearchLabel}}</button>
            </div>
        </div>
        <!----end oksearch module----->
        <!--footer-->
        <footer>
            <div class="serp-footer">
                <div class="logoFooter"><img :src="branding.Logo"><span><i class="fa fa-copyright" aria-hidden="true"></i> <span id="brandDetails"> {{branding.Trademark}}</span> </span></div>
                <ul>
                    <li><a :href="`https://${branding.RootDomain}/terms-of-service/`">Terms of Service </a></li>
                    <li><a :href="`https://${branding.RootDomain}/privacy-policy/`">Privacy</a></li>
                    <li><a :href="`https://${branding.RootDomain}/contact-us/`">Contact Us</a></li>
                </ul>
            </div>
        </footer>
        <!--end of footer-->
    </div>
</template>

<script>
    "use strict"
    import bp  from "babel-polyfill"
    import queryString  from 'query-string'
    import 'whatwg-fetch'
    import Humanize from 'humanize-plus'
    import {getGuid, getSetting, setSetting} from "../storage"
    import {WEB_SEARCH_URL, MAP_SEARCH_API, openUrl}  from '../urls'
    import FirstRun from '../components/FirstRun.vue'
    import {getBranding, PRODUCT_SEARCH_PROVIDERS, DEFAULT_PRODUCT_SEARCH_PROVIDER}  from "../branding"
    import {documentReady} from '../common'
    import {findProductProvider} from '../packagetracker'

    function validatePop(name){
        switch(name){
            case "intro":
            case "i":
                return "intro"
            case "t":
            case "tutorial":
                return "tutorial"
            case "it":
                return "intro-tutorial"
        }

        return false;
    }

    export default {
        name: 'serp',
        components:{
            'first-run':FirstRun
        },
        data(){
            let qs  = queryString.parse(window.location.search);
            return {
                query: qs.q || '',
                queryError: false,
                engineError: false,
                recentSearches: [],
                guid: qs.guid,
                whichPop: validatePop(qs.pop) || false ,
                branding: getBranding(),
                productEngine: qs.engine || DEFAULT_PRODUCT_SEARCH_PROVIDER,
                productSearchProviders: PRODUCT_SEARCH_PROVIDERS,
                findProductProvider:findProductProvider
            }
        },
        mounted(){
            documentReady.then(async () => {
                this.recentSearches = JSON.parse(getSetting("recentSearches")) || [];
                try {
                    this.guid = await getGuid();
                }
                catch (e) {
                    // Extension not available.
                }
                this.$refs.queryInput.focus();
                if (this.query && !this.whichPop)
                {
                    this.productEngine=this.findProductProvider(this.query,this.productEngine);
                    await this.toProductSearch();
                }
            })
        },
        methods: {
            validateMapSearch(withFocus) {
                let {query} = this;
                let errs=false;
                if(query == ""){
                    errs=  errs  || {}
                    errs.query = "This field is required, Please enter"
                }
                this.queryError=errs;
                if(withFocus){
                    if(errs.query)  this.$refs.queryInput.focus();
                }
                return errs === false;
            },
            async toProductSearch() {
                if(!this.validateMapSearch(true)) return;
                if (this.recentSearches.unshift(this.query) > 5) {
                    this.recentSearches.pop();
                }
                setSetting("recentSearches", JSON.stringify(this.recentSearches));
                if (this.forceRedirect){
                    this.productEngine=this.findProductProvider(this.query, this.productEngine);
                    if (this.productEngine==DEFAULT_PRODUCT_SEARCH_PROVIDER)
                    {
                        this.engineError=true;
                    }
                    else
                    {
                        this.engineError=false;
                        await this.doSearch(this.query);
                    }
                } else
                await this.doSearch(this.query);
            },
            async doSearch(term) {
                await openUrl(PRODUCT_SEARCH_PROVIDERS[this.productEngine || DEFAULT_PRODUCT_SEARCH_PROVIDER].url.replace("{{QUERY}}", term), false);
            },
            onNextPop(tag) {
                this.whichPop=validatePop(tag) || false;
            },
            async onCloseHelp() {
                switch(this.whichPop){
                    case "intro-tutorial":
                    this.whichPop = validatePop("i");
                    return;
                }
                this.whichPop=false
                if (this.query)
                {
                    this.productEngine=this.findProductProvider(this.query,this.productEngine);
                    await this.toProductSearch();
                }
            }
        },
        computed: {
            forceRedirect(){
                return this.productEngine==DEFAULT_PRODUCT_SEARCH_PROVIDER;
            }
        }
    }
</script>

<style>
    @import './css/search.css';
</style>
